import '../events/page-view-event.mjs';
import { CustomEvent } from '../events/custom-event.mjs';
import '../utils/consts.mjs';

class EventQueue {
    constructor(storage, eventApiClient, infer) {
        this.storage = storage;
        this.eventApiClient = eventApiClient;
        this.infer = infer;
        /**
         * Initialize the Event Storage
         * @param storage - Interface that describes the storage functionality
         * @param eventApiClient - The API client which sends events to CDP
         * @param infer - The instance of the infer class
         */
        this.key = 'EngageEventQueue';
    }
    /** Returns the stored array of data with type QueueEventPayload, or empty array if the given key does not exist. */
    getEventQueue() {
        const storedQueue = this.storage.getItem(this.key);
        if (!storedQueue)
            return [];
        try {
            const parsedQueueEvent = JSON.parse(storedQueue);
            return Array.isArray(parsedQueueEvent) ? parsedQueueEvent : [];
        }
        catch (_a) {
            return [];
        }
    }
    /**
     * Adds the required event data to the queue and stores it in the storage.
     * @param queueEventPayload - The required event data for the creation of a CustomEvent.
     * Performs validation by creating a new CustomEvent.
     */
    enqueueEvent(queueEventPayload) {
        var _a, _b;
        queueEventPayload.eventData.page = (_a = queueEventPayload.eventData.page) !== null && _a !== void 0 ? _a : this.infer.pageName();
        queueEventPayload.eventData.language = (_b = queueEventPayload.eventData.language) !== null && _b !== void 0 ? _b : this.infer.language();
        new CustomEvent({
            eventApiClient: this.eventApiClient,
            infer: this.infer,
            ...queueEventPayload,
        });
        const eventQueue = this.getEventQueue();
        eventQueue.push(queueEventPayload);
        this.storage.setItem(this.key, JSON.stringify(eventQueue));
    }
    /**
     * Iterates the queue, and sends sequently the custom events to Sitecore CDP.
     */
    async sendAllEvents() {
        const eventQueue = this.getEventQueue();
        for (const queueEventPayload of eventQueue) {
            await new CustomEvent({
                eventApiClient: this.eventApiClient,
                eventData: queueEventPayload.eventData,
                extensionData: queueEventPayload.extensionData,
                id: queueEventPayload.id,
                infer: this.infer,
                settings: queueEventPayload.settings,
                type: queueEventPayload.type,
            }).send();
        }
        this.clearQueue();
    }
    /**
     * Clears the queue from storage.
     */
    clearQueue() {
        this.storage.removeItem(this.key);
    }
}

export { EventQueue };
